// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainLayout_mainProviderLayoutContainer__B8VyK .MainLayout_layoutContainer__UQ-Ut {
  margin-top: 80px;
  overflow-x: auto;
  height: calc(100vh - 80px);
}`, "",{"version":3,"sources":["webpack://./src/component/common/layouts/main/MainLayout.module.scss"],"names":[],"mappings":"AAEE;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;AADJ","sourcesContent":[".mainProviderLayoutContainer {\n  \n  .layoutContainer {\n    margin-top: 80px;\n    overflow-x: auto;\n    height: calc(100vh - 80px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainProviderLayoutContainer": `MainLayout_mainProviderLayoutContainer__B8VyK`,
	"layoutContainer": `MainLayout_layoutContainer__UQ-Ut`
};
export default ___CSS_LOADER_EXPORT___;
